export const ACCESS_TIERS = {
  FREE: "free_core",
  CORE: "research_plus",
  COMING_SOON: "coming_soon",
  OWNER: "private_owner",
  NOT_FOUND: "not_found",
};

const FREE_ROUTES = new Set([
  "/setup",
  "/onboarding",
  "/dashboard",
  "/holdings",
  "/cashflow",
  "/watchlist",
  "/dictionary",
  "/learn/today",
  "/principles",
  "/search",
  "/charts",
  "/research",
  "/import",
  "/manual-entry",
  "/access-control",
  "/tax-awareness",
]);

const CORE_ROUTES = new Set([
  "/discover",
  "/explore",
  "/screener",
  "/screener/etf",
  "/screener/thai",
  "/screener/funds",
  "/fair-value",
  "/valuation-drilldown",
  "/valuation",
  "/buy-decision",
  "/lens-comparison",
  "/lens-alerts",
  "/relationship-graph",
  "/relationships",
  "/scenario-studio",
  "/scenarios",
  "/decision-ledger",
  "/ledger",
  "/allocation-controller",
  "/allocation",
  "/analytics",
  "/analytics-v2",
  "/risk",
  "/financial-wellness",
  "/debt-optimizer",
  "/my-finances",
  "/health-dashboard",
  "/health",
  "/performance",
  "/benchmark",
  "/portfolio-explorer",
  "/portfolio-quality",
  "/simulate",
  "/explorer",
  "/portfolio-intelligence",
  "/portfolio-digest",
  "/backtest",
  "/whatif",
  "/what-if",
  "/income",
  "/dividend-projector",
  "/look-through",
  "/currency-risk",
  "/international",
  "/rebalance",
  "/timeline",
  "/networth",
  "/candidates",
  "/pipeline",
  "/evidence",
  "/xray",
  "/review-queue",
  "/review",
  "/actions",
  "/holdings-intraday",
  "/sleeves",
  "/controller",
  "/thesis",
  "/pl-analytics",
  "/market-overview",
  "/macro",
  "/news",
  "/earnings",
  "/position-sizer",
  "/tax-loss",
  "/dca-scheduler",
  "/journal",
  "/compare",
  "/mutual-funds",
  "/sector-heatmap",
  "/peer-comparison",
  "/research-hub",
  "/dividends",
  "/lens-diagnostics",
  "/dictionary-review",
  "/system-logic",
  "/intelligence",
  "/account-activity",
  "/cap-analysis",
  "/queue-allocator",
  "/correlation",
  "/monte-carlo",
  "/email-reports",
  "/batch-operations",
  "/fx-exposure",
  "/treemap",
  "/holdings-compare",
  "/share",
  "/snapshot-compare",
  "/app-versions",
  "/beam",
  "/bdd",
  "/review-cadence",
  "/investor-journey",
  "/investor-score",
  "/ticker-evaluation",
  "/council",
  "/council-brief",
  "/council-orchestrator",
  "/quiz",
  "/learn/curriculum",
  "/wealth-studio",
  "/brain",
  "/portfolio-doctor",
  "/research-copilot",
  "/strategy-labs",
  "/ai-engine",
]);

const COMING_SOON_ROUTES = new Set([
  "/ai-approval",
]);

const OWNER_ROUTES = new Set([
  "/neo-intelligence",
  "/fund-os",
  "/neo-agents",
  "/ai-clone",
  "/ai-strict-clone",
  "/ai-compare",
  "/ai-what-changed",
  "/ai-history",
  "/fund-settings",
]);

function cleanPath(pathname = "") {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "") || "/";
}

export function getRouteTier(pathname) {
  const path = cleanPath(pathname);
  if (path === "/holding" || path.startsWith("/holding/")) return ACCESS_TIERS.FREE;
  if (/^\/holdings\/[^/]+$/.test(path)) return ACCESS_TIERS.FREE;
  if (path === "/cashflow" || path.startsWith("/cashflow/")) return ACCESS_TIERS.FREE;
  if (path === "/charts" || path.startsWith("/charts/")) return ACCESS_TIERS.FREE;
  if (path === "/research" || path.startsWith("/research/")) return ACCESS_TIERS.FREE;
  if (FREE_ROUTES.has(path)) return ACCESS_TIERS.FREE;
  if (CORE_ROUTES.has(path)) return ACCESS_TIERS.CORE;
  if (COMING_SOON_ROUTES.has(path)) return ACCESS_TIERS.COMING_SOON;
  if (OWNER_ROUTES.has(path)) return ACCESS_TIERS.OWNER;
  return ACCESS_TIERS.NOT_FOUND;
}

export function canShowNavItem(item, entitlements = {}) {
  const tier = item.tier || getRouteTier(item.path);
  if (tier === ACCESS_TIERS.FREE) return Boolean(entitlements.isResearchPlus || item.showInFreeNav !== false);
  if (tier === ACCESS_TIERS.CORE) return Boolean(entitlements.isResearchPlus || item.showWhenLocked);
  if (tier === ACCESS_TIERS.COMING_SOON) return true;
  if (tier === ACCESS_TIERS.OWNER) return Boolean(entitlements.is_owner);
  return false;
}

export function isNavLocked(item, entitlements = {}) {
  const tier = item.tier || getRouteTier(item.path);
  return tier === ACCESS_TIERS.CORE && !entitlements.isResearchPlus;
}
